/**
 * Experiment to give retailers a personalized FOI with $300 cap.
 * https:www.notion.so/faire/Personalized-FOI-V2-1732efb5c25a806cb6add9c96bd370ff
 */ export var PERSONALIZED_FOI_V2_250114 = 'PERSONALIZED_FOI_V2_250114';
